import axios from "axios";

import { BACKEND_URL } from "../constants"

const listDiscountCodes = () => {
  const url = `${BACKEND_URL}/api/v1/thinkific/discount-codes/s/`;
  return axios.get(url);
}

const createDiscountCodes = (file) => {
  const url = `${BACKEND_URL}/api/v1/thinkific/discount-codes/s/`;
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(url, formData);
}

export const thinkificServices = {
  listDiscountCodes,
  createDiscountCodes,
};